import { Box, Button, Checkbox, FormControlLabel, FormGroup, Menu, MenuItem, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import useMenu from "../../../base/hooks/useMenu";
import { IconArrowDownFill } from "../../../base/icons/svg";
const useStyles = makeStyles()(theme => {
    return {
        btnSelect: {
            '&.MuiButton-outlined': {
                borderColor: '#AAAAAA',
                color: theme.palette.default00,
                backgroundColor: 'white',
                padding: '5px 15px',
                '&:hover': {
                    backgroundColor: 'white',
                    borderColor: theme.palette.borderHover
                },
                '&[aria-expanded="true"]': {
                    borderColor: theme.palette.borderHover,
                    padding: '4px 15px'
                },
                '& .MuiButton-endIcon': {
                    width: '24px',
                    height: '24px'
                }
            }
        }
    };
});
/**
 * Component filter search
 * @param {*} status: Danh sách trạng thái cần filter
 * @param {*} label: Tên filter search
 * @param {*} labelkey: Key tên filter search
 * @returns
 */
const Filter = ({ status = [], label, labelkey, handleAction }) => {
    const { classes } = useStyles();
    const { open, anchorEl, setAnchorEl } = useMenu();
    const { t } = useTranslation();
    const [checked, setChecked] = useState(() => {
        return status.map(() => false);
    });
    /**
     * Chọn status filter
     * @param {*} e
     * @param {*} index
     */
    const handleChecked = (e, index) => {
        let _checked = [...checked];
        _checked.splice(index, 1, e.target.checked);
        if (!_checked.some(check => check))
            _checked = status.map(() => false);
        setChecked(_checked);
        handleAction && handleAction(_checked);
    };
    /**
     * Thông tin các filter đã chọn
     * @returns
     */
    const renderListStatus = () => {
        let listStatus = '';
        checked.forEach((check, index) => {
            if (check)
                listStatus += t('filter.select.' + status[index]) + ' ';
        });
        return listStatus;
    };
    return (React.createElement(Box, null,
        React.createElement(Box, { display: 'flex', alignItems: 'center', gap: 3 },
            React.createElement(Typography, { sx: { display: { xs: 'none', sm: 'block' }, whiteSpace: 'nowrap', color: '#44494d', fontWeight: 500 } }, label || labelkey && t(labelkey)),
            React.createElement(Button, { sx: { minHeight: 32 }, variant: 'outlined', className: classes.btnSelect, "aria-controls": open ? 'menu-filter-status' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: (e) => setAnchorEl(e?.currentTarget), endIcon: React.createElement(IconArrowDownFill, null) },
                React.createElement(Typography, { sx: { whiteSpace: 'nowrap', fontWeight: '600' } }, ((checked.every(check => check) || checked.every(check => !check)) && ((checked?.length === status?.length) || checked?.length === 0)) ? t('filter.select.all') : renderListStatus()))),
        React.createElement(Menu, { anchorEl: anchorEl, open: open, onClose: () => setAnchorEl(null) },
            React.createElement(FormGroup, { sx: { display: 'flex', flexDirection: 'column' } }, status.map((item, index) => (React.createElement(MenuItem, { sx: { padding: 0 } },
                React.createElement(FormControlLabel, { key: item, sx: { padding: `0 20px`, margin: 0, width: '100%' }, control: React.createElement(Checkbox, { checked: checked[index], onChange: (e) => handleChecked(e, index) }), label: t('filter.select.' + item) }))))))));
};
export default Filter;
